import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../styles/Header.css";
import { useUser } from "../contexts/UserContext";

const DEFAULT_LOGO = "/whLogoFull.png";

const Header = () => {
  const { pathname } = useLocation();
  const isAisprawl = pathname.startsWith("/aisprawl");
  const title = isAisprawl ? "AI Sprawl" : "AI Attack Surface Management";
  const { license } = useUser();

  const candidates = [license?.logo_url, DEFAULT_LOGO].filter(Boolean);
  const [srcIndex, setSrcIndex] = useState(0);

  useEffect(() => {
    setSrcIndex(0);
  }, [license?.logo_url]);

  const logoSrc = candidates[srcIndex];

  return (
    <header className="header">
      {logoSrc && (
        <div className="icon" aria-hidden="true">
          <img
            className="header-logo"
            src={logoSrc}
            alt=""
            onError={() => setSrcIndex((i) => i + 1)}
          />
        </div>
      )}
      <h1 className="title">{title}</h1>
    </header>
  );
};

export default Header;
